<div class="memic-panel panel">
  <div class="panel-heading">
    <h3 class="panel-title">{{title}}</h3>
  </div>
  <div class="panel-body">
    <div *ngIf="!resources">
      <em>Loading Resources...</em>
    </div>
    <ul class="memic-list memic-list--details memic-list--brdless list-group m-a-0" *ngFor="let r of resources; index as i;">
      <li class="memic-list__body list-group-item p-x-0">
        <div class="memic-list__body-left">
          <img #fileIcon class="memic-icn memic-icn-png" [src]="'../assets/icons/' + r.blobExtension.replace('.', '') +'.png'">
        </div>
        <div class="memic-list__body-right">
          <header class="memic-list__header">
            <h2 class="memic-list__title"><a href="javascript:void(null)" (click)="downloadFile(r, fileIcon)">{{r.title}}</a></h2>
          </header>
          <div class="memic-list__content">{{r.resourceDescription}}</div>
        </div>
      </li>
    </ul>
  </div>
</div>
